module.exports = __webpack_public_path__ + "img/13.bf10fc29.png";